module.exports = __webpack_public_path__ + "static/technologist-light-skin-1de631b91d9d2e4783ebc9e61842d7ea.png";